<template>
    <div class="top-nav">
        <img class="nav__logo" :src="require('../assets/logo.png')" />
        <div class="nav__menu text font-medium">
            <router-link to="/">
                <p>Home</p>
            </router-link>
            <!-- <router-link :to="{ path: '/', hash: 'benefits' }">
                <p>Benefits</p>
            </router-link> -->
            <router-link to="contact">
		<p>Contact</p>
            </router-link>
            <router-link v-if="!isLoggedIn" to="login">
                <p class="button--outline">Login</p>
            </router-link>
        </div>
    </div>
</template>

<script>
import store from "@/store";
import { computed } from "vue";

export default {
    name: "TopNav",

    setup() {
        const isLoggedIn = computed(() => store.state.user != null);

        return { isLoggedIn };
    },
};
</script>

<style lang="scss">
.top-nav {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 10px 20px;

    img {
        width: 120px;
    }

    .nav__menu {
        display: flex;
        align-items: center;

        p {
            margin-right: 30px;
            margin-top: 20px;
            padding: 0 10px;
            &:hover {
                border-bottom: 2px solid $yellow;
                cursor: pointer;
            }
        }

        .button--outline {
            border: 2px solid $yellow;
            padding: 2px 20px;
            border-radius: 8px;

            &:hover {
                background-color: #ffd8761a;
            }
        }
    }
}
.button--inline {
    display: inline;
}
</style>
